module.exports = __webpack_public_path__ + "static/media/ProjectInsight002.5b3c3ce9.png";